// ViewInvoiceModal.jsx
import React from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import "moment/locale/pt-br";
import _ from "lodash";
import { DeliveryStatus } from "./../DeliveryStatus";
import {
  calculateProductsTotal,
  formatCurrencyFromCents,
  formatCurrency,
  formatDate,
} from "./invoiceParsers";
import "./Invoices.css";
import NumberFormat from "react-number-format";
import { translateStatus, PaymentMethod } from "../../utils/pagarme";

moment.locale("pt-br");

const ViewInvoiceModal = ({ isOpen, toggle, order, gerarBoletoUrl }) => {
  if (!order) return null;

  const totalProducts = calculateProductsTotal(order);
  const deliveryDate = order.delivery?.delivery_date
    ? moment(order.delivery.delivery_date)
    : null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="modal-view modal-lg modal-dialog-centered"
    >
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <div className="success-screen">
          <div className="thank-you text-center">
            <i className="fa fa-check-circle-o"></i>
            <h1 className="text-white">Obrigado pela compra.</h1>
            <span>
              A compra foi realizada e o seu pedido está sendo processado.
            </span>
            <strong className="text-white">
              Código de Compra: {order.code}{" "}
            </strong>
          </div>

          {order.products && order.products.length > 0 ? (
            <>
              {deliveryDate && (
                <div className="delivery p-4 p-md-5 bg-light text-center">
                  <span className="h5">Data prevista da chegada:</span>
                  <h2 className="mb-0 mt-2">
                    {deliveryDate.format("DD")} de{" "}
                    {deliveryDate.format("MMMM, YYYY")}
                  </h2>
                </div>
              )}

              <div className="p-4 p-md-5">
                <Row>
                  <Col lg={7} className="text-left mt-4 mt-lg-0">
                    <h6>Endereço de entrega:</h6>
                    <ul className="list-unstyled mb-0">
                      <li>
                        Nome: <strong>{order.delivery?.name}</strong>
                      </li>
                      <li>
                        Email: <strong>{order.customer?.email}</strong>
                      </li>
                      <li>
                        Celular:{" "}
                        <strong>{order.customer?.phone_numbers?.[0]}</strong>
                      </li>
                      <li>
                        Data de nascimento:
                        <strong>
                          {" "}
                          {order.customer?.birthday
                            ? formatDate(order.customer.birthday)
                            : ""}
                        </strong>
                      </li>
                      <li>
                        Endereço:{" "}
                        <strong>
                          {order.delivery?.address?.street},{" "}
                          {order.delivery?.address?.street_number}
                        </strong>
                      </li>
                      {order.delivery?.address?.complementary && (
                        <li>
                          Complemento:{" "}
                          <strong>
                            {order.delivery.address.complementary}
                          </strong>
                        </li>
                      )}
                      <li>
                        Cidade/UF:{" "}
                        <strong>
                          {order.delivery?.address?.city} /{" "}
                          {order.delivery?.address?.state?.toUpperCase()}
                        </strong>
                      </li>
                      <li>
                        CEP: <strong>{order.delivery?.address?.zipcode}</strong>
                      </li>
                      <li>
                        Tipo de entrega:
                        <strong> {order.tracking?.description}</strong>
                      </li>
                      <li>
                        Status da entrega:{" "}
                        <strong>{order.tracking?.status}</strong>
                      </li>
                    </ul>
                  </Col>

                  <Col lg={5} className="text-left mt-4 mt-lg-0">
                    <h6>Resumo da compra:</h6>
                    <ul className="list-unstyled mb-0">
                      <li>
                        <span>Código:</span> <strong>{order.code}</strong>
                      </li>
                      <li>
                        <span>Observação:</span>{" "}
                        <strong>{order.observation}</strong>
                      </li>
                      <li>
                        <span>Data:</span>{" "}
                        <strong>
                          Dia{" "}
                          {order.dataTransaction
                            ? moment(order.dataTransaction).format("DD")
                            : ""}{" "}
                          de{" "}
                          {order.dataTransaction
                            ? moment(order.dataTransaction).format("MMMM, YYYY")
                            : ""}
                          .
                        </strong>
                      </li>
                      <li>
                        <span>Horário:</span>{" "}
                        <strong>
                          {order.dataTransaction
                            ? moment(order.dataTransaction).format("HH")
                            : ""}{" "}
                          horas e{" "}
                          {order.dataTransaction
                            ? moment(order.dataTransaction).format("mm")
                            : ""}{" "}
                          minutos.
                        </strong>
                      </li>
                      <li>
                        <span>Valor total do pagamento:</span>{" "}
                        <strong>{formatCurrencyFromCents(order.amount)}</strong>
                      </li>
                      <li>
                        <span>Status do pedido: </span>
                        <strong>{translateStatus(order.status)}</strong>
                      </li>
                      <li>
                        <span>Forma de pagamento:</span>{" "}
                        <span className="text-capitalize">
                          <strong>{PaymentMethod(order.paymentMethod)}</strong>
                        </span>
                      </li>

                      {order.installments > 1 && (
                        <li>
                          <span>Parcelas:</span>{" "}
                          <strong>
                            {order.installments}x de{" "}
                            <NumberFormat
                              value={order.amount / 100 / order.installments}
                              displayType="text"
                              thousandSeparator="."
                              prefix="R$"
                              decimalScale={2}
                              fixedDecimalScale
                              decimalSeparator=","
                            />
                          </strong>
                        </li>
                      )}
                    </ul>

                    {order.coupon && (
                      <div className="mt-2">
                        <strong>O cupom {order.coupon} foi aplicado.</strong>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div>Não existe produtos dessa compra.</div>
          )}

          {order.products && order.products.length > 0 ? (
            <div className="ordered-detail">
              <h6>Detalhes da compra:</h6>
              <div className="table-responsive">
                <ul className="list-unstyled d-flex justify-content-center col-12 flex-wrap">
                  {order.products.map((CartItem, index) => (
                    <li
                      className="media mb-3 col-12 col-lg-6"
                      key={CartItem._id || index}
                    >
                      <img
                        width={60}
                        height={76}
                        src={CartItem.ProductImage}
                        className="img-fluid mr-3"
                        alt={CartItem.ProductName}
                      />
                      <div className="media-body">
                        <div className="mt-0 mb-1 col-12">
                          <strong>{CartItem.ProductName}</strong>
                        </div>
                        <div className="col-12">
                          Quantidade: {CartItem.ProductQuantity}
                        </div>
                        <div className="col-12">
                          Tamanho: {CartItem.ProductSize}
                        </div>
                        <div className="col-12">
                          Cor: {CartItem.ProductColor?.colorName}
                        </div>
                        <div className="col-12">
                          Preço:{" "}
                          {CartItem.ProductSale ? (
                            <>
                              <span className="text-sale mr-2">
                                {formatCurrency(
                                  CartItem.ProductPrice *
                                    CartItem.ProductQuantity,
                                )}
                              </span>
                              <span className="currency-symbol">
                                {formatCurrency(
                                  CartItem.ProductSalePrice *
                                    CartItem.ProductQuantity,
                                )}
                              </span>
                            </>
                          ) : (
                            <span className="currency-symbol">
                              {formatCurrency(
                                CartItem.ProductPrice *
                                  CartItem.ProductQuantity,
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="table-responsive">
                <table className="table total-table table-borderless mt-4">
                  <tbody>
                    <tr>
                      <td>Total da compra:</td>
                      <td className="text-right">
                        {formatCurrency(totalProducts)}
                      </td>
                    </tr>
                    <tr>
                      <td>Frete:</td>
                      <td className="text-right">
                        {formatCurrencyFromCents(order.delivery?.fee)}
                      </td>
                    </tr>
                    <tr className="border-top">
                      <td>
                        <strong className="h5">Total com frete: </strong>
                      </td>
                      <td className="text-right h5">
                        <strong>{formatCurrencyFromCents(order.amount)}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="p-3">Carregando produtos.</div>
          )}

          <div className="d-sm-flex p-3">
            {order.tracking && !_.isEmpty(order.tracking.status_list) ? (
              <DeliveryStatus
                type={order.tracking.type}
                statusList={order.tracking.status_list}
              />
            ) : null}
          </div>

          <div className="d-sm-flex px-4 pb-4 px-md-5 pb-md-5">
            {order.paymentMethod === "boleto" &&
            order.status === "waiting_payment" ? (
              <Link className="button ml-auto" onClick={gerarBoletoUrl}>
                Gerar Boleto{" "}
                <i className="glyph-icon pgsicon-ecommerce-invoice" />
              </Link>
            ) : null}

            <Link className="button ml-3" onClick={toggle}>
              Voltar
            </Link>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewInvoiceModal;
